<template>
    <generic-element-tile-container v-if="mode === 'tiles'"
        :id="media.id"
        :small="small"
        :colClass="elementClass"
        :cardClass="['media-card media-file', selected ? 'selected' : '']"
        entityName="media"
    >
        <div class="element-data"
            :data-file-id="media.id"
            :data-type="media.media_type"
            :data-width="media.informations.width"
            :data-height="media.informations.height"
            :data-page-count="media.informations.count"
            :data-duration="media.informations.duration"
            :data-valid-from="media.parameters['valid-from']"
            :data-valid-to="media.parameters['valid-to']"
            :data-file-name="media.file_name + '.' + media.file_extension"
            :data-preview-name="media.original_image"
            :data-display-name="media.display_name"
        />

        <generic-element-tile
            :id="`media-info-${media.id}`"
            :img="media"
            :src="media.thumbnail"
            :height="'150px'"
            :isVideo="media.media_type === 'video'"
            :addMode="media.media_type.indexOf('placeholder') !== -1"
            :noIcon="media.file_name === 'dummy_placeholder'"
            @click="showMedia"
        />

        <v-card-actions :id="'media-actions-' + media.id" v-if="actionsAvailable">
            <v-btn icon v-if="deletePrivilege === '1' || editPrivilege === '1'" @click="selectMedia()" :color="selected ? 'primary' : ''">
                <v-icon>{{ selected ? 'fa-regular fa-square-check' : 'fa-regular fa-square' }}</v-icon>
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn icon v-if="editPrivilege === '1'" @click="editMedia()" :color="selected ? 'primary' : ''">
                <v-icon>fa-regular fa-pencil</v-icon>
            </v-btn>

            <v-btn icon v-if="deletePrivilege === '1'" @click="deleteMedia()" :color="selected ? 'primary' : ''">
                <v-icon>fa-regular fa-trash</v-icon>
            </v-btn>
        </v-card-actions>

    </generic-element-tile-container>
</template>

<script>
    import VTooltipWrapper from '../../common/v-tooltip-wrapper.vue'
    import GenericElementTile from "../common/genericElementTile.vue";
    import GenericElementTileContainer from "../common/genericElementTileContainer.vue";

    export default {
        components: {
            GenericElementTileContainer,
            GenericElementTile,
            VTooltipWrapper,
        },
        props: [
            'media',
            'small',
            'mode',
            'viewPrivilege',
            'editPrivilege',
            'deletePrivilege',
            'dragDrop',
            'elementClass'
        ],
        data: function () {
            return {
                t_added: Lang.langGet("Added"),
                t_modified: Lang.langGet("Modified"),
                t_edit: Lang.langGet("Edit"),
                t_delete: Lang.langGet("Delete"),
                t_validity: Lang.langGet("Validity"),
                t_file_name: Lang.langGet("Filename"),
                activeProject: Laravel.activeProject,
                selected: false,
            }
        },
        computed: {
            actionsAvailable: function () {
                return this.deletePrivilege === '1' || this.editPrivilege === '1';
            },
            tooltipHtml() {
                let data = this.media.display_name + '<br/>';
                if (this.media.file_name !== this.media.display_name) {
                    data = data + this.t_file_name + ': ' + this.media.file_name + '.' + this.media.file_extension + '<br/>';
                }
                data = data + this.t_validity + ': ' +  this.media.parameters['validity-text'] + '<br/>' +
                    this.t_added + ': ' + this.media.created_at + '<br/>' +
                    this.t_modified + ': ' + this.media.updated_at;
                return data;
            }
        },
        methods: {
            editMedia: function () {
                EaseEventBus.fire('editMedia', this.media);
            },
            deleteMedia: function () {
                EaseEventBus.fire('deleteMedia', this.media);
            },
            showMedia: function () {
                if (this.media.file_name === 'dummy_placeholder') {
                    EaseEventBus.fire('newContent', this.media.media_type);
                } else {
                    EaseEventBus.fire('showMedia', this.media);
                }
            },
            selectMedia: function () {
                this.selected = !this.selected;
                EaseEventBus.fire('selectMedia');
            }
        },
        mounted() {
            EaseEventBus.listen('updateMedialist', () => {
                this.selected = false;
            });
        }
    }
</script>
